import { render, staticRenderFns } from "./Part5Layout.vue?vue&type=template&id=6628d682&scoped=true"
import script from "./Part5Layout.vue?vue&type=script&lang=ts"
export * from "./Part5Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=6628d682&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6628d682",
  null
  
)

export default component.exports